import { PermissionType, TeamRole } from '../../api/graphql/generated';
import { i18nKeyType } from '../../i18n';

// These types map one to one with server types
export enum RolePermissionInputType {
  NUMBER = 'number',
  PERCENTAGE = 'percentage',
  SELECT = 'select',
}

export enum CrudPermissionAction {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
}

export interface RolePermissionTemplateMetadata
  extends Record<string, unknown> {
  fieldName: string;
  fieldApiName: string;
  rolePermissionInputType: Array<RolePermissionInputType>;
}

export const RolePermissionCrudFieldApiName = 'crud';

export interface RolePermissionSelectMetadata
  extends RolePermissionTemplateMetadata {
  rolePermissionInputType: [RolePermissionInputType.SELECT];
  options: { label: string; value: unknown }[];
  multiple?: boolean;
}

export interface RolePermissionEntityCrudMetadata
  extends RolePermissionSelectMetadata {
  options: { label: string; value: CrudPermissionAction }[];
  multiple: true;
  fieldApiName: PermissionType;
}

export interface RolePermissionUserdata extends Record<string, unknown> {
  rolePermissionInputType: RolePermissionInputType;
  rolePermissionInputValue?: unknown;
}

export interface NumericRolePermissionUserdata extends RolePermissionUserdata {
  rolePermissionInputType:
    | RolePermissionInputType.NUMBER
    | RolePermissionInputType.PERCENTAGE;
  rolePermissionInputValue: number;
}

export interface SelectRolePermissionUserdata extends RolePermissionUserdata {
  rolePermissionInputType: RolePermissionInputType.SELECT;
  rolePermissionInputValue: string;
}

export interface MultiSelectRolePermissionUserdata
  extends RolePermissionUserdata {
  rolePermissionInputType: RolePermissionInputType.SELECT;
  rolePermissionInputValue: (string | number)[];
}

// The following types are not mirrored on the server
export const RolePermissionInputToLocalizedKey: Record<
  RolePermissionInputType,
  i18nKeyType | undefined
> = {
  [RolePermissionInputType.NUMBER]: 'common:number',
  [RolePermissionInputType.PERCENTAGE]: 'common:percentage',
  // a user shouldn't be able to have a select type as an option to choose
  // when creating a role permission
  [RolePermissionInputType.SELECT]: undefined,
};

export const RoleTypeToLocalizedKey: Record<TeamRole, i18nKeyType> = {
  [TeamRole.EDITOR]: 'common:editor',
  [TeamRole.MANAGER]: 'common:manager',
  [TeamRole.VIEWER]: 'common:viewer',
  [TeamRole.OPERATOR]: 'common:operator',
};
